/* eslint-disable no-unused-vars */
import Swiper from 'swiper/swiper-bundle';

function careersMobileMenu() {
    const menuToggle = document.getElementById('careersMenu__toggle');
    const menuEl = document.getElementById('careersMenu__MobileNavWrapper');

    // if menuToggle doesn't exist, return
    if (!menuToggle) {
        return;
    }

    menuToggle.setAttribute('aria-expanded', 'false');
    menuToggle.setAttribute('aria-controls', 'careersMenu__MobileNavWrapper');
    menuToggle.setAttribute('aria-haspopup', 'true');
    menuToggle.setAttribute('role', 'button');
    menuToggle.setAttribute('tabindex', '0');
    menuEl.setAttribute('aria-hidden', 'true');
    menuEl.setAttribute('aria-labelledby', 'careersMenu__toggle');
    menuEl.setAttribute('role', 'menu');
    menuEl.setAttribute('tabindex', '-1');

    menuToggle.addEventListener('click', () => {
        menuEl.classList.toggle('active');
        // update aria-expanded attribute
        if (menuEl.classList.contains('active')) {
            menuToggle.setAttribute('aria-expanded', 'true');
            menuEl.setAttribute('aria-hidden', 'false');
        } else {
            menuToggle.setAttribute('aria-expanded', 'false');
            menuEl.setAttribute('aria-hidden', 'true');
        }

    });

    // Close filter menu when clicking outside of it
    document.addEventListener('click', (event) => {
        if (!event.target.closest('.careersMenu__toggle')) {
            menuEl.classList.remove('active');
            menuToggle.setAttribute('aria-expanded', 'false');
            menuEl.setAttribute('aria-hidden', 'true');
        }
    });

    // close filter menu when escape key is pressed
    document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
            menuEl.classList.remove('active');
            menuToggle.setAttribute('aria-expanded', 'false');
            menuEl.setAttribute('aria-hidden', 'true');
        }
    });

}

function careersHero() {
    const heroModules = document.querySelectorAll('.careersHero__module');
    heroModules.forEach((module) => {
        const moduleTarget = module.querySelector('.careersHero__moduleTarget');
        const moduleContent = module.querySelector('.careersHero__moduleContent');

        const mediaQuery = '(min-width: 641px)';
        const mediaQueryList = window.matchMedia(mediaQuery);

        function setAttributes() {
            // find first module
            const firstModule = document.querySelector('.careersHero__module:first-of-type');
            firstModule.classList.add('active');

            // add unique id to each moduleContent
            const moduleContentId = moduleContent.getAttribute('id');

            moduleTarget.setAttribute('aria-haspopup', 'true');
            moduleTarget.setAttribute('aria-controls', moduleContentId);

            // get index of module
            const moduleIndex = Array.prototype.indexOf.call(heroModules, module);
            // if moduleIndex is 0, set aria attributes
            if (moduleIndex === 0) {
                moduleTarget.setAttribute('aria-expanded', 'true');
                moduleContent.setAttribute('aria-hidden', 'false');
            } else {
                moduleTarget.setAttribute('aria-expanded', 'false');
                moduleContent.setAttribute('aria-hidden', 'true');
            }
        }

        function unsetAttributes() {
            module.classList.remove('active');
            moduleTarget.removeAttribute('aria-haspopup');
            moduleTarget.removeAttribute('aria-controls');
            moduleTarget.removeAttribute('aria-expanded');
            moduleContent.removeAttribute('aria-hidden');
        }

        mediaQueryList.addEventListener('change', event => {
            if (event.matches) { // > 641px
                setAttributes();
            } else { // < 640px
                unsetAttributes();
            }

        });

        // check mediaQueryList on page load
        if (mediaQueryList.matches) { // > 641px
            setAttributes();
        } else { // < 641px
            unsetAttributes();
        }

        moduleTarget.addEventListener('click', () => {
            if (mediaQueryList.matches) { // > 641px
                  
                // if module is already active, return
                if (module.classList.contains('active')) {
                    return;
                }
                // close all other modules
                heroModules.forEach((module) => {
                    module.classList.remove('active');
                    module.querySelector('.careersHero__moduleTarget').setAttribute('aria-expanded', 'false');
                    module.querySelector('.careersHero__moduleContent').setAttribute('aria-hidden', 'true');
                });

                module.classList.toggle('active');
                moduleTarget.setAttribute('aria-expanded', 'true');
                moduleContent.setAttribute('aria-hidden', 'false');

            }

        });

    });

}

function careersJobCarousel() {
    const carousels = document.getElementsByClassName('careersCarousel__main');
    if (!carousels.length) return;

    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper('.careersCarousel__carousel', {
        // Optional parameters
        slidesPerView: 2.8,
        slidesPerGroup: 1,
        loop: true,
        spaceBetween: 182,
        grabCursor: true,
        watchOverflow: true,
        centeredSlides: true,
        centerInsufficientSlides: true,
        roundLengths: true,
        speed: 500,

        // Navigation arrows
        navigation: {
            nextEl: `.careersCarousel__sliderControl-next`,
            prevEl: `.careersCarousel__sliderControl-prev`,
        },
        breakpoints: {
            300: {
                slidesPerView: 1.4,
                spaceBetween: 20,
            },
            480: {
                slidesPerView: 1.8,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 80,
            },
            1000: {
                slidesPerView: 2.4,
                spaceBetween: 100,
            },
            1390: {
                slidesPerView: 2.8,
                spaceBetween: 182,
            },
        }
    });
}


/**
 * Function to run when this module is called from site.js
 */
const init = () => {

    careersMobileMenu();
    careersHero();
    careersJobCarousel();
    
};

export default init;
